/**
 * Feature Flags — toggle features pending client confirmation
 */
export const FEATURE_FLAGS = {
  /** Show city filter on the Dashboard (pending client confirmation) */
  ENABLE_CITY_FILTER: true,
};
